import "./bootstrap";

import App from "./App.vue";
import autoResize from "./directives/auto-resize.js";
import numericOnly from "./directives/numeric-only.js";
import inputResize from "./directives/auto-inputSize.js";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { createPinia } from "pinia";
import optimistic from "@/directives/optimistic.js";
import router from "./router/router.js";
import VueLazyLoad from "vue3-lazyload";
import LaravelPermissionToVueJS from "laravel-permission-to-vuejs";
import posthog from "posthog-js";
import mixpanel from "./services/metrics/mixpanel.js";

const pinia = createPinia();
const i18n = createI18n({
    legacy: false,
    locale: "en",
    fallbackLocale: "en",
});

const app = createApp(App);

app.directive("optimistic", optimistic);
app.directive("autoResize", autoResize);
app.directive("numericOnly", numericOnly);
app.directive("inputResize", inputResize);

app.use(VueLazyLoad, {
    loading: "/images/imageLoading.webp",
    error: "",
    lifecycle: {
        loading: () => {},
        error: () => {},
        loaded: () => {}
    }
});

app.use(LaravelPermissionToVueJS);
app.use(mixpanel);

// Initialize PostHog only if API key is available
if (import.meta.env.VITE_POSTHOG_API_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
        api_host: import.meta.env.VITE_POSTHOG_HOST,
        person_profiles: import.meta.env.VITE_POSTHOG_PERSON_PROFILES, // You can change this to 'always' if needed
    });
    app.config.globalProperties.$posthog = posthog;
}

app.use(pinia).use(router).use(i18n).mount("#app");
